import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { useParams } from 'react-router-dom';
import * as XLSX from "xlsx"
import moment from "moment";

let options = [];
const Descargas = () => {
    let { Pedido } = useParams();
    let { p1 } = useParams();
    let { p2} = useParams();
    let { p3 } = useParams();

    const [Listado, SetListado] = useState([]);

    
    useEffect(() => {
        if (Pedido == 1) {
            obtenerDatos()
        } 
       
        
    }, [])

   


    const obtenerDatos = async () => {
        let fi = moment(p1).format("YYYY-MM-DD");
        let ff = moment(p2).format("YYYY-MM-DD");
        p3 = parseInt(p3)
        let response = await fetch(Api + "Pacientes/ListaReporteAtendido/" + p1 + "/" + p2 + "/" + p3);

        if (response.ok) {
            let data = await response.json()

            SetListado(data);
            data.map(x => {
                options.push({
                    pacienteID: x.pacienteID, nombres: x.nombres, apellidos: x.apellidos,
                    fechaNacimiento: moment(x.fechaNacimiento).format("DD/MM/YYYY"), sexo: x.sexo,
                    cedula: x.cedula, telefono: x.telefono, celular: x.celular, nombreSeguro: x.nombreSeguro,
                    poliza: x.poliza
                })
            })

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.json_to_sheet(options);
                XLSX.utils.book_append_sheet(wb, ws, "Reporte");
            XLSX.writeFile(wb, "Reporte de pacientes en el rango de fecha " + p1 + " al " + p2 + ".xlsx")
            window.close();
        }
    }



    return (
        <>
         
        </>
        )

}
export default Descargas;